import { isAxiosError } from 'axios'
import { t } from 'i18next'

export const getUploadErrorMessage = (error: unknown): string => {
  if (isAxiosError(error)) {
    const data = error.response?.data as { message?: string | string[] } | undefined
    const msg = data?.message
    if (Array.isArray(msg)) return msg.join(', ')
    if (typeof msg === 'string' && msg.length > 0) return msg
    if (error.message === 'Network Error') {
      return t('Upload:networkError')
    }
  }
  if (error instanceof Error) return error.message
  return t('Upload:unknownError')
}
